import React, { useEffect, useState } from "react";
import i18n from "i18next";

import ConfiguratorStPanel from "../../ConfiST/ConfiguratorStPanel";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { IKonfigurationSt } from "../../../Models/IKonfigurationSt";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  Input,
  Button,
  Field,
  TabList,
  Tab,
  MessageBar,
  Spinner,
  ProgressBar,
} from "@fluentui/react-components";
import {
  DismissRegular,
  FilterRegular,
  IosArrowRtl24Regular,
  MailSettingsRegular,
  SearchRegular,
} from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";
import LuebPagedDataGrid from "../../../Controls/LuebPagedDataGrid";
import { ColumnsConfiStSales } from "./ColumnsConfiStSales";
import Header from "../../Layout/Header";
import useWindowSize from "../../../helpers/useWindowSize";
import HeaderTextAnimation from "../../Layout/HeaderTextAnimation";

function ConfiSTSales(props: any) {
  const windowSize = useWindowSize();
  const navigate = useNavigate();
  const [openConfigs, setOpenConfigs] = useState<IKonfigurationSt[]>([]);
  const [closedConfigs, setClosedConfigs] = useState<IKonfigurationSt[]>([]);
  const [clickedConfig, setClickedConfig] = useState<IKonfigurationSt>();
  const [loading, setLoading] = useState<boolean>(false);

  const [userNameFilter, setUserNameFilter] = useState("");
  /* window.location?.search?.substring(
      window.location?.search?.indexOf("userNameFilter=") + 15,
    ), */

  const [selectedTabValue, setSelectedTabValue] =
    useState<string>("offeneAnfragen");
  const [openConfigurator, setOpenConfigurator] = useState<boolean>(false);

  const getOpenConfigs = () => {
    setLoading(true);
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/vertrieb/GetConfiguratorConfigs?status=40&usernameFilter=${userNameFilter}`,
      )
      .then((data: any) => {
        setOpenConfigs(data);
        setLoading(false);
      });
  };

  const getClosedConfigs = () => {
    setLoading(true);
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/vertrieb/GetConfiguratorConfigs?status=100&usernameFilter=${userNameFilter}`,
      )
      .then((data: any) => {
        setClosedConfigs(data);
        setLoading(false);
      });
  };

  /* useEffect(() => {
    if (columns.clickedConfig) {
      openPanel();
    }
  }, [columns.clickedConfig]); */

  useEffect(() => {
    /* if (!openConfigurator) { */
    if (selectedTabValue == "offeneAnfragen") {
      getOpenConfigs();
    } else {
      getClosedConfigs();
    }
    /* } */
  }, [openConfigurator, selectedTabValue]);

  useEffect(() => {
    if (openConfigs || closedConfigs) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            setClickedConfig(
              selectedTabValue == "offeneAnfragen"
                ? openConfigs.find((x) => x.userObjectGuid == guid)
                : closedConfigs.find((x) => x.userObjectGuid == guid),
            );
          }
        } else {
          setClickedConfig(undefined);
        }
      }
    }
  }, [openConfigs, closedConfigs, window.location.search]);
  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1400 ||
              windowSize.width < 1024 ||
              !clickedConfig) && (
              <Button
                icon={<MailSettingsRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/sales/configurator");
                }}
              >
                {i18n.t<string>("configuratorRequests").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1401 &&
              windowSize.width > 1024 &&
              clickedConfig && (
                <Button
                  style={{ paddingLeft: "0px" }}
                  size="small"
                  onClick={() => {
                    navigate("/sales/configurator");
                  }}
                  appearance="transparent"
                >
                  <MailSettingsRegular fontSize={24} color="#ff6600" />
                </Button>
              )}
            {clickedConfig && (
              <>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button appearance="transparent">
                  {clickedConfig.id}
                  <div style={{ marginLeft: "5px", marginRight: "5px" }}>:</div>

                  <HeaderTextAnimation
                    text={
                      i18n.language.includes("de") &&
                      clickedConfig.positionen[0].artikel?.benennungDE
                        ? clickedConfig.positionen[0].artikel?.benennungDE
                        : clickedConfig.positionen[0].artikel?.benennungEN
                        ? clickedConfig.positionen[0].artikel?.benennungEN
                        : ""
                    }
                  />
                </Button>
              </>
            )}
          </StackShim>
        }
      />

      {!clickedConfig && (
        <>
          <div className="lueb-InnerContentBlockPadding2px">
            <Button
              appearance="transparent"
              icon={<SearchRegular />}
              onClick={() => {
                if (selectedTabValue == "offeneAnfragen") {
                  getOpenConfigs();
                } else {
                  getClosedConfigs();
                }
              }}
            >
              {i18n.t<string>("suchen")}
            </Button>
          </div>

          <div className="lueb-ContentBlock">
            <Field label={"Gesendet von (Email)"}>
              <Input
                placeholder="Email-Adresse"
                value={userNameFilter}
                contentAfter={
                  userNameFilter ? (
                    <Button
                      appearance="transparent"
                      icon={<DismissRegular />}
                      onClick={() => {
                        setUserNameFilter("");
                      }}
                    />
                  ) : (
                    <FilterRegular />
                  )
                }
                onChange={(ev, data) => {
                  setUserNameFilter(data ? data.value : "");
                }}
              />
            </Field>
          </div>
          <TabList
            selectedValue={selectedTabValue}
            onTabSelect={(ev, data) => {
              if (typeof data.value == "string") {
                setSelectedTabValue(data.value);
              }
            }}
          >
            <Tab value={"offeneAnfragen"}>Offene Anfragen</Tab>
            <Tab value={"geschlosseneAnfragen"}>Geschlossene Anfragen</Tab>
          </TabList>

          <div className="lueb-ContentBlock">
            {loading == false && (
              <LuebPagedDataGrid
                sortable
                columns={ColumnsConfiStSales({
                  openDialogWithConfig: (item) => {
                    /* setOpenConfigurator(true); */

                    setClickedConfig(item);
                    if (item.userObjectGuid != undefined) {
                      navigate(
                        "/sales/configurator?guid=" + item.userObjectGuid,
                      );
                    }
                  },
                })}
                items={
                  selectedTabValue == "offeneAnfragen"
                    ? openConfigs
                    : closedConfigs
                }
                resizableColumns={true}
                columnSizingOptions={undefined}
              />
            )}
            {loading == true && <ProgressBar thickness="large" />}
            {selectedTabValue == "offeneAnfragen" &&
              openConfigs.length == 0 && (
                <MessageBar intent="info">
                  {i18n.t<string>("noItemsFound")}
                </MessageBar>
              )}
            {selectedTabValue == "geschlosseneAnfragen" &&
              closedConfigs.length == 0 && (
                <MessageBar intent="info">
                  {i18n.t<string>("noItemsFound")}
                </MessageBar>
              )}
          </div>
        </>
      )}

      <ConfiguratorStPanel
        isPanelOpen={
          /* openConfigurator == true && */ clickedConfig != undefined
        }
        onDismiss={() => {
          navigate("/sales/configurator");
          setClickedConfig(undefined);
        }}
        config={clickedConfig}
      />
    </div>
  );
}

export default ConfiSTSales;
